import { render, staticRenderFns } from "./NewInvitationModal.vue?vue&type=template&id=ade07c9c&"
import script from "./NewInvitationModal.vue?vue&type=script&lang=js&"
export * from "./NewInvitationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports